import React from "react";
import { useNavigate } from "react-router-dom";
import { TopBar } from "../../widgets";
import { GnbFooter } from "../../shared";

const centeredText: React.CSSProperties = {
    position: "absolute",
    top: "50%",
    width: "100%",
    transform: "translateY(-50%)",
    textAlign: "center",
};

const headerCell: React.CSSProperties = {
    position: "relative",
    fontSize: 16,
    height: 40,
};

const contentCell: React.CSSProperties = {
    position: "relative",
    backgroundColor: "#FFF",
    fontSize: 14,
    height: 80,
};

const MemberShip = () => {
    const navigate = useNavigate();

    return <>
        <div style={{ background: "#F2F2F2", minHeight: "100vh" }}>
            <TopBar title="멤버십 안내" rightIcon={false} />
            <div style={{ margin: "auto 20px" }}>
                <div style={{
                    fontSize: "18px",
                    lineHeight: 1.4,
                    fontWeight: "bold",
                    color: "#111",
                    marginTop: 36,
                }}>
                    Membership
                </div>
                <div style={{
                    color: "#555",
                    fontSize: "14px",
                    lineHeight: 1.35,
                    fontWeight: 400,
                    letterSpacing: "-0.4px",
                    marginTop: 10,
                }}>
                    파지티브호텔 요가 회원 등급별로<br />할인 및 적립 혜택이 제공됩니다.
                </div>
                <div style={{
                    display: "flex",
                    gap: 7,
                    fontWeight: 600,
                    lineHeight: 1.4,
                    color: "#000",
                    marginTop: 23,
                }}>
                    <div style={{ flex: 1 }}>
                        <div style={{
                            ...headerCell,
                            backgroundColor: "#C1CCCE",
                            borderTopLeftRadius: 2,
                            borderTopRightRadius: 2,
                        }}>
                            <span style={centeredText}>
                                STANDARD
                            </span>
                        </div>
                        <div style={contentCell}>
                            <span style={centeredText}>
                                파지티브호텔<br />앱 다운로드 고객
                            </span>
                        </div>
                    </div>
                    <div style={{
                        flex: 1,
                        borderTopLeftRadius: 2,
                        borderTopRightRadius: 2,
                        overflow: "hidden",
                    }}>
                        <div style={{
                            ...headerCell,
                            backgroundColor: "#93A9AD",
                        }}>
                            <span style={centeredText}>
                                SUITE
                            </span>
                        </div>
                        <div style={contentCell}>
                            <span style={centeredText}>
                                파지티브호텔<br />정기권 구매 고객
                            </span>
                        </div>
                        <div style={{
                            ...contentCell,
                            borderTop: "1px dashed #999",
                        }}>
                            <span style={centeredText}>
                                적립 3%
                            </span>
                        </div>
                        <div style={{
                            ...contentCell,
                            borderTop: "1px dashed #999",
                        }}>
                            <span style={centeredText}>
                                선릉 도산<br />스튜디오 이용 가능
                            </span>
                        </div>
                        <div style={{
                            ...contentCell,
                            borderTop: "1px dashed #999",
                        }}>
                            <span style={centeredText}>
                                드링크 서비스<br />웰니스샷 제공
                            </span>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: 30 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "#555", marginBottom: "10px", lineHeight: 1 }}>
                        유의사항
                    </div>
                    <ul style={{
                        fontSize: 10,
                        fontWeight: 500,
                        color: "#555",
                        listStyleType: "none",
                        paddingLeft: 4,
                        lineHeight: 1.8,
                    }}>
                        <li>&nbsp;&middot;&nbsp; 파지티브호텔 멤버쉽은 앱 다운로드를 필수로 합니다.</li>
                        <li>&nbsp;&middot;&nbsp; 포인트는 클래스, F&B, MD 이용시 적립됩니다.</li>
                        <li>&nbsp;&middot;&nbsp; 웰니스샷 혜택은 프로모션에 따라 변경될 수 있습니다.</li>
                    </ul>
                </div>
                <div
                    onClick={() => navigate("/wellness-ticket-group")}
                    style={{
                        height: "56px",
                        backgroundColor: "#000000",
                        color: "#FFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        fontWeight: "500",
                        margin: "30px 0",
                        cursor: "pointer",
                        borderRadius: 5,
                    }}>
                    정기권 구매하러 가기
                </div>
            </div>
            <GnbFooter activeButton='my' />
        </div>
    </>
}
export default MemberShip;
